/**
 * Translates contest area to contest name
 *
 * @flow
 */
import green from "@material-ui/core/colors/green";
import blue from "@material-ui/core/colors/blue";
import orange from "@material-ui/core/colors/orange";
import amber from "@material-ui/core/colors/amber";
import purple from "@material-ui/core/colors/purple";

export const CONTEST_AREA_SA = {
  MEXICO_AND_CENTRAL_AMERICA: {
    name: "Mexico and Central America",
    color: orange[500],
    colorHovered: orange[600],
    abbr: "mexico",
  },
  CARIBBEAN: {
    name: "Caribbean",
    color: purple[500],
    colorHovered: purple[600],
    abbr: "caribfinals",
  },
  SOUTH_AMERICA_NORTH: {
    name: "South America/North",
    color: green[500],
    colorHovered: green[600],
    abbr: "south-america-north",
  },
  SOUTH_AMERICA_BRAZIL: {
    name: "South America/Brazil",
    color: amber[500],
    colorHovered: amber[600],
    abbr: "south-america-brazil",
  },
  SOUTH_AMERICA_SOUTH: {
    name: "South America/South",
    color: blue[500],
    colorHovered: blue[600],
    abbr: "southamerica-south",
  },
};

export type ICPCContest = {
  abbr: string,
  name: string,
  color: string,
  colorHovered: string,
};

const nameToContestArea = {
  Mexico: CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  Guatemala: CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  Honduras: CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  Belize: CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  socen: CONTEST_AREA_SA.SOUTH_CENTRAL,
  "El Salvador": CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  Nicaragua: CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  "Costa Rica": CONTEST_AREA_SA.MEXICO_AND_CENTRAL_AMERICA,
  Panama: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Colombia: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Ecuador: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Venezuela: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Guyana: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Suriname: CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  "French Guiana": CONTEST_AREA_SA.SOUTH_AMERICA_NORTH,
  Brazil: CONTEST_AREA_SA.SOUTH_AMERICA_BRAZIL,
  Peru: CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  Bolivia: CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  Paraguay: CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  Uruguay: CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  Argentina: CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  "Falkland Islands": CONTEST_AREA_SA.SOUTH_AMERICA_SOUTH,
  Bahamas: CONTEST_AREA_SA.CARIBBEAN,
  Cuba: CONTEST_AREA_SA.CARIBBEAN,
  Jamaica: CONTEST_AREA_SA.CARIBBEAN,
  "Puerto Rico": CONTEST_AREA_SA.CARIBBEAN,
  Haiti: CONTEST_AREA_SA.CARIBBEAN,
  "Dominitican Republic": CONTEST_AREA_SA.CARIBBEAN,
};

export function toICPCContest(geographyProperty: Object): ICPCContest {
  // custom countries
  // we are using objects/hash maps to be faster than switch/ifs since this is evaluated on every iteration
  return (
    nameToContestArea[geographyProperty.geounit] || {
      name: "",
      color: "#00000000",
      colorHovered: "#00000000",
      abbr: "undefined",
    }
  );
}
